import { render, staticRenderFns } from "./UssdPollCenter.vue?vue&type=template&id=c8329e4a&scoped=true&"
import script from "./UssdPollCenter.vue?vue&type=script&lang=js&"
export * from "./UssdPollCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8329e4a",
  null
  
)

export default component.exports